export default "__VITE_ASSET__BCZbdX$m__"